// src/MenuCategorias.jsx

import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../../helpers/indexedDbHelper';
import { useRefresh } from '../../../hooks/useRefresh';
import ListProducts from '../ListProducts';
import LayoutContent from '../../../components/layouts/content2';

export default function MenuCategorias({setshowFajitas}) {
  

   const [showListProduct, setShowListProduct] = useState(false);
   const [dishs, setdishs] = useState(false);
   const {change} = useRefresh();
  const [menus, setMenus] = useState([]);

  const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);


   useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

  
  useEffect(() => {
          menus.map((item) => {
          if (item.id === 586) {
              setDataDesserts(item);
          }
  
          if (item.id === 588) {
              setDataDrinks(item);
          }
          });
      }, [menus]);
  
  
  return (
    <div style={{position: 'absolute', top: -10, left: 0, width: '100%', height: '100%', zIndex: 999}}>
      <LayoutContent showBack={true} showLogo={true} setShowListProduct={()=> setshowFajitas(false)}>


        <div style={{paddingInline: 1}}>
            <img
                src={require('./assets/banner.png')}
                
                style={{
                    width: '100%',
                    height: 340,
                    borderRadius: 14,
                    objectFit: 'contain',
                    boderRadius: 20,
                }}
             />
        </div>
        
        <div style={{display: 'flex', justifyContent: 'start', alignItems: 'center', paddingInline: 1}}>
          <img
                src={require('./assets/text.png')}
                
                style={{
                    width: 400,
                    height: 250,
                    borderRadius: 14,
                   marginLeft: 10,
                    objectFit: 'contain',
                    boderRadius: 20,
                }}
          />
        </div>


      <div
          style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginBottom: 10,
            marginTop: -10,
            paddingInline: 1,
              boxSizing:  'border-box'
          }}>
              <img
                  style={{
                  width: '39%',
                  height: 10,
                  }}
                  src={require('../assets/brand.png')}
              />
              <p
              style={{
              alignSelf: 'center',
              fontSize: 20,
                  textTransform: 'uppercase',
                  color: 'white',
                  fontWeight: '900',
              
          }}>
          ¡NO OLVIDES!
          </p>
          <img
              style={{
              width: '39%',
              height: 10,
              }}
              src={require('../assets/brand.png')}
          />
        </div>
        

        <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingInline: 1
                        }}>
                        <div onClick={()=>[setShowListProduct(true), setdishs(dataDesserts)]}  >
                            <img
                            src={require('../assets/App-26.png')}
                            resizeMode={'cover'}
                            style={{
                                width: 320,
                                height: 230,
                                borderRadius: 14,
                                marginBottom: 10,
                                objectFit: 'cover',
                                boderRadius: 20,
                            }}
                            />
                        </div>

                    <div onClick={()=>[setShowListProduct(true), setdishs(dataDrinks)]}>
                            <img
                                src={require('../assets/App-27.png')}
                                resizeMode={'cover'}
                            style={{
                                width: 320,
                                height: 230,
                                borderRadius: 14,
                                marginBottom: 10,
                                objectFit: 'cover',
                                boderRadius: 20,
                            }}
                            />
                        </div>
                    </div>
      {showListProduct && <ListProducts
        top={-6}
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
  </LayoutContent>
    </div>
  );
}
